export const WISTIA_URL = 'https://home.wistia.com/medias/';
